
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/luts",
      function () {
        return require("private-next-pages/luts/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/luts"])
      });
    }
  